let shoesdata = [

    {
        Id: "1",
        img: "images/manSport/shoes1.jpg",
        name: "Men Simba PRO Running Shoes",
        price: "809 $",
        color: "Black,White",
        brand: "Campus",
        catagary: "Man's Sport Shoes",
    },
    {
        Id: "2",
        img: "images/manSport/shoes2.jpg",
        name: "Men Future-01 White Shoes",
        price: "549 $",
        color: "Black,White,Gray,Red",
        brand: "Asian",
        catagary: "Man's Sport Shoes",

    },
    {
        Id: "3",
        img: "images/manSport/shoes3.jpg",
        name: "Men Flex Experience Run 11 Next Nature",
        price: "4995 $",
        color: "Blue",
        brand: "Nike",
        catagary: "Man's Sport Shoes",
    },
    {
        Id: "4",
        img: "images/manSport/shoes4.jpg",
        name: "Men Navy Blue Mesh SM-482 Running Shoes ",
        price: "849 $",
        color: "Blue",
        brand: "Spark",
        catagary: "Man's Sport Shoes",
    },
    {
        Id: "5",
        img:"images/manFormal/shoes5.jpg",
        name: "The Hoboken Patent Oxfords ",
        color: "Black",
        brand: "Spark",
        price: "9999 $",
        catagary: "Man's Formal Shoes"
    },
    {
        Id: "6",
        img:"images/manFormal/shoes6.jpg",
        name: "Brown Elegant Look Slip Resistance Office Wear ",
        color: "brown",
        brand: "Spark",
        price: "600 $",
        catagary: "Man's Formal Shoes"
    },
    {
        Id: "7",
        img:"images/manFormal/shoes7.jpg",
        name: "formal shoes ",
        color: "blue",
        brand: "Spark",
        price: "423 $",
        catagary: "Man's Formal Shoes"
    },
    {
        Id: "8",
        img:"images/manFormal/shoes8.jpg",
        name: "Black & Brown Mens Formal Shoes ",
        color: "black",
        brand: "Spark",
        price: "475.00$ - 1200.00 $",
        catagary: "Man's Formal Shoes"
    },
    {
        Id: "9",
        img:"images/ladiesShoes/shoes9.jpg",
        name: "Office Wear Black Women Formal Shoes ",
        color: "black",
        brand: "IQRA ENTERPRISES",
        price: "220 $",
        catagary: "Ladies Shoes"
    },
    {
        Id: "10",
        img:"images/ladiesShoes/shoes10.jpg",
        name: "Women Comfortable And Long Lasting Black Synthetic Plain Formal Shoes ",
        color: "black",
        brand: "IQRA ENTERPRISES",
        price: "800 $",
        catagary: "Ladies Shoes"
    },
    {
        Id: "11",
        img:"images/ladiesShoes/shoes11.jpg",
        name: "Champs Women's Casual Shoes ",
        color: "Onion",
        brand: "IQRA ENTERPRISES",
        price: "599 $",
        catagary: "Ladies Shoes"
    },
    {
        Id: "12",
        img:"images/ladiesShoes/shoes12.jpg",
        name: "Flooristo Stylish Latest Fashion Sneakers Shoes for Girls/Women",
        color: "Pink",
        brand: "IQRA ENTERPRISES",
        price: "519 $",
        catagary: "Ladies Shoes"
    },
    {
        Id: "13",
        img:"images/ladiesSandle/sandle1.jpg",
        name: "Women Black Casual Sandals",
        color: "black",
        brand: "Mochi",
        price: "1690 $",
        catagary: "Ladise Sandel"
    },
    {
        Id: "14",
        img:"images/ladiesSandle/sandle2.jpg",
        name: "Women Flat Sandals",
        color: "blue",
        brand: "Mochi",
        price: "295 $",
        catagary: "Ladise Sandel"
    },
    {
        Id: "15",
        img:"images/ladiesSandle/sandle3.jpg",
        name: "Ladies Sandal Women Flats Black Slippers ",
        color: "Black",
        brand: "Mochi",
        price: "600 $",
        catagary: "Ladise Sandel"
    },
    {
        Id: "16",
        img:"images/ladiesSandle/sandle4.jpg",
        name: "Women's Pink Solea Sandals ",
        color: "Pink",
        brand: "Mochi",
        price: "700 $",
        catagary: "Ladise Sandel"
    },



]

export default shoesdata;